import { UnnamedWidget } from 'lib-node-amb-renderer';

export class YAMLOopsClass extends UnnamedWidget {
  header: string;
  message: string;

  constructor(props) {
    super(props);
    this.header = props.header;
    this.message = props.message;
  }
}

export { default } from './OopsComponent';
